export default "__VITE_ASSET__B2R85pvo__"